import EnterTransferCodeModal from "./EnterTransferCodeModal";

export default EnterTransferCodeModal;
